import {
  GET_WIDGETS_BY_PAGE_ID_SUCCESS,
} from './constants'

const initialState = {
  actualWidgets: []
}

function widgetsReducer(state = initialState, { type, payload }) {
  switch (type) {
    case GET_WIDGETS_BY_PAGE_ID_SUCCESS:
      return {
        ...state,
        actualWidgets: payload,
      }
    default:
      return state
  }
}

export default widgetsReducer
